import CurrencyIcon from './CurrencyIcon';
import ShopWallet from '@/external/icons/ShopWallet';

type Props = {
  currency?: string;
};

const SelectionIcon: FC<Props> = ({ currency }) => {
  if (!currency) {
    return (
      <ShopWallet className="rounded-full bg-trunks p-0.5 text-beerus rem:text-[28px]" />
    );
  }
  return <CurrencyIcon currency={currency} />;
};

export default SelectionIcon;
